module.exports = __webpack_public_path__ + "img/answer_8.749b77b6.png";